import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Called when user clicks "Copy Transcript" button',
  name: 'copied_transcript_segment',
  params: [
    {
      description: 'The ID of clip',
      name: 'clip_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The start time of the segment in milliseconds',
      name: 'start_time_ms',
      required: true,
      type: 'number',
    },
    {
      description: 'The end time of the segment in milliseconds',
      name: 'end_time_ms',
      required: true,
      type: 'number',
    },
  ],
};

export default META;
